export default "__VITE_ASSET__cdf3b30a__"